<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Entry Pass to Sale</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="product_type_id">Entry Pass Type</label>
      <select id="product_type_id"
              name="product_type_id"
              class="custom-select"
              [(ngModel)]="lineItem.product_type_id"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit">
        <option [ngValue]="null">---</option>
        <option *ngFor="let entryPass of entryPasses"
                [ngValue]="entryPass.id">
          {{ entryPass.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <p class="mb-2">Assigned Customer</p>

      <p *ngIf="lineItem.customer_id !== null" class="indented-subsection">
        <b>{{ lineItem.customer_first_name }} {{ lineItem.customer_last_name }}</b>
        <br>
        {{ dateStringFromISO8601(lineItem.customer_birthday) }}
        <br>
        <span *ngIf="lineItem.customer_email">
          {{ lineItem.customer_email }}
        </span>
        <span *ngIf="!lineItem.customer_email" class="text-muted">
          No email address
        </span>
      </p>

      <button class="btn btn-sm btn-primary mb-2"
              type="button"
              [disabled]="loadingSubmit || purchasingCustomerIsAssigned()"
              [class.disabled]="loadingSubmit || purchasingCustomerIsAssigned()"
              (click)="assignPurchasingCustomer()">
        {{ purchasingCustomerIsAssigned() ? 'Purchasing Customer Selected' : 'Select Purchasing Customer' }}
      </button>
      <br>
      <button class="btn btn-sm btn-primary mb-2"
              type="button"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit"
              (click)="openSelectCustomerModal()">
        Select Other Customer
      </button>
      <br>
      <button class="btn btn-sm btn-primary"
              type="button"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit"
              (click)="openCreateCustomerModal()">
        Create New Customer
      </button>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!allFieldsEntered()"
            [class.disabled]="!allFieldsEntered()"
            (click)="handleSubmit()"
            *ngIf="!loadingSubmit">
      Submit
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
